import styled from "styled-components";
import { mediaQueries } from "../../styles/media-queries";
import 'antd/lib/table/style';

const ContainerStyle = styled.div`
	table {
		tr {
			cursor: pointer;
			
			td:nth-child(2) {
				text-align: center;
			}

			td:last-child {
				text-align: right;
			}
		}
	}
`;

const ClubName : any = styled.span`
	&::after {
		content: "${(props: any) => props.shortName}"; 
	}	

	@media ${mediaQueries.tablet} {
		&::after {
			content: "${(props: any) => props.fullName}"; 
		}
	}	
`;


const FiltersArea = styled.div`
	text-align: center;
	margin: 0 20px 20px 20px;

	.ant-btn-primary {
		color: ${props => props.theme.primaryColor};
		background-color: #9E9E9E;
	}

	.ant-select {
		max-width: 150px;
	}
` as any;

export {
	ContainerStyle,
	FiltersArea,
	ClubName
};